
<template>
      <section class="page-section nav-section options" id="route-options-section">
       <!-- <Modal v-if="modalOpen" :Selected="strategies.selected" :imgName="imageName" /> -->
        <Modal v-if="showModal" @close="showModal = false" :imgName="imageName"/>

      
       <!-- Odal -->
                   
        <!-- modal end -->
      <div class="container">
          <div class="row">
                <div class="col m12 l12">
                    <div class="text-wrap center-align">
                        <div>
                            <p class="hr-title"><hr class="hr-purple"><b>Route Options</b></p>
                            <h1>Routes Considered</h1>
                            <p class="resize">Please take a look at all our different route considerations. If you have any feedback please view our feedback page and you can have input into the ongoing changes!</p>
                        </div>
                    </div>
                </div>
          </div>
        <div class="article-nav">
          
          <hr class="header-underline" />
          <div class="navs">
            <div
              v-for="(strategy, index) in strategies.strats"
              :key="`strategies_navs_${index}`"
            >
              <h2
                v-if="index !== strategies.selected"
                @click="() => selectStrategy(index)"
              >
                {{ strategy.shortHeader }}
              </h2>
              <h2 v-if="index === strategies.selected" class="active">
                {{ strategy.shortHeader }}
              </h2>
            </div>
          </div>
          <div class="selects">
            <form>
              <select v-model="strategies.selected">
                <option
                  v-for="(strategy, index) in strategies.strats"
                  :key="`strategies_option_${index}`"
                  :value="index"
                >
                  {{ strategy.shortHeader }}
                </option>
              </select>
            </form>
          </div>
          
          <hr style="margin-bottom: 4rem" />

          <div class="nav-content">
            <div class="row">
              <div class="col-md-12 col-sm-12 col-lg-7">
                <div class="nav-text">
                  
                    <p
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].text"
                      :key="`strategies_text_${index}`"
                      v-html="text"
                    >
                    </p>
                  
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalText"
                      :key="`strategies_additionaltext_${index}`"
                    >
                      {{ p }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-lg-5">
                 <inner-image-zoom :src="require(`@/assets/images/Belfast/Maps/${strategies.strats[strategies.selected].imageRight }`)" />
                <!-- <div
                  class="img"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/images/Belfast/Maps/' +
                        strategies.strats[
                        strategies.selected
                      ].imageRight ) +
                      ')',
                  }"
                > -->

                  <!-- <div class="modalOpenButton" @click="openModal(strategies.strats[strategies.selected].imageRight)">
                    <i class="fas fa-expand"></i>
                  </div>
                   -->
                   <!-- <div class="modalOpenButton" id="show-modal" @click="showModalNow(strategies.strats[strategies.selected].imageRight)">
                    <i class="fas fa-expand"></i>
                  </div> -->
                      <!-- <div>

                        <button id="show-modal" @click="showModal = true">Show Modal</button>
     
     

                      </div> -->
                </div>
              </div>
            </div>

            <!-- new start -->
            <div class="row">
              
              <div class="col-md-12 col-sm-12 col-lg-7">
                <div class="nav-text">
                  <!-- <h2>{{ strategies.strats[strategies.selected].headerMore }}</h2>
                  <h5>{{ strategies.strats[strategies.selected].textMoreHeader }}</h5> -->
                  <div>
                    <p
                      v-for="(text, index) in strategies.strats[
                        strategies.selected
                      ].textMore"
                      :key="`strategies_text_${index}`"
                       v-html="text"
                    >

                    </p>
                  </div>
                  <div>
                    <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].additionalTextMore"
                      :key="`strategies_additionaltext_${index}`"
                    >
                      {{ p }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-lg-5">
                 <inner-image-zoom :src="require(`@/assets/images/Belfast/Maps/${strategies.strats[strategies.selected].imageLeft }`)" v-if="strategies.strats[strategies.selected].imageLeft!=''"/>
                <!-- <div
                v-if="strategies.strats[strategies.selected].imageLeft!=''"
                  class="img"
                  :style="{ backgroundImage: 'url(' + require('@/assets/images/Belfast/Maps/'+strategies.strats[strategies.selected].imageLeft ) +')'}"
                > -->
                <!-- <div class="modalOpenButton" id="show-modal" @click="showModalNow(strategies.strats[strategies.selected].imageLeft)">
                    <i class="fas fa-expand"></i>
                </div> -->
                  <!-- <div class="modalOpenButton" @click="openModal(strategies.strats[strategies.selected].imageLeft)">
                    <i class="fas fa-expand"></i>
                  </div> -->
                </div>
              </div>
            </div>



            <!-- new end-->
                        <div class="text-wrap center-align">
                        <div>
                            <p class="hr-title"><hr class="hr-purple " style="width:100%"></p>
                        </div>
                        </div>
            <!-- Additional New -->
            <div class="row" >
              <div class="col s12 l6">
                <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].textMoreAdditionalRight"
                      :key="`strategies_additionaltext_${index}`"
                      v-html="p"
                    >
                      
                    </p>
              </div>
              <div class="col s12 l6">
                <div class="nav-text">
                   <p
                      v-for="(p, index) in strategies.strats[
                        strategies.selected
                      ].textMoreAdditionalLeft"
                      :key="`strategies_additionaltext_${index}`"
                      v-html="p"
                    ></p>
                  
                </div>
              </div>
              
            </div>
            <!-- Additional End -->
          </div>
        </div>
      </div>
    </section>
</template>
<script>
import InnerImageZoom from 'vue-inner-image-zoom'
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
import Modal from "@/components/customPages/components/MapModal";
export default {
  name: "option-section",
   components: {
    Modal,
    InnerImageZoom
  },
  data() {
    return {
      showModal: false,
        modalOpen:false,
        imageName:'',
       strategies: {
        selected: 0,
        
        strats: [
          {
           imageRight:"city.png",
             imageLeft:"",
            shortHeader: "Glider G2 Extension",
            textAdditional:false,
             textMore: [],
            text: [
                  "<h2>Route assessed as being <u>suitable</u></h2><h5>Glider G2 Extension</h5>",
                  "<p>This circulatory option runs from the existing G2 network at Howard Street - Great Victoria Street - Bruce Street - Dublin Road - University Road, then connects with the Lisburn Road via Elmwood Avenue and back to the City Centre via Lisburn Road and Great Victoria Street. This route forms an extension to the existing G2 service which extends to the Titanic Quarter via the City Centre network. </p>", 
                  "<p>This route facilitates significant priority for BRT2 using the existing roads and will enhance accessibility to Queen’s University and Belfast City Hospital as well as serving the communities of Sandy Row, Donegall Pass, Botanic and Holylands. Elmwood Avenue is proposed to be converted to one-way operation in the direction of Lisburn Road with the existing on-street parking retained.</p>",
                  "<h2>Routes assessed as being <u>unsuitable</u></h2><h5>Glider G2 Extension Anti-clockwise along University Street / Lisburn Road</h5>",
                  "<p>This anti-clockwise route runs from Lisburn Road via either Fitzwilliam Street, Wellesley Avenue, Wellington Park or Eglantine Avenue, connecting to the City Centre via University Road and Dublin Road. This route forms an extension to the existing G2 service which extends to the Titanic Quarter via the City Centre network.</p>", 
                  "<p>This option was ruled out due to the need to board and alight on the opposite side of the road for Queen’s University and Belfast City Hospital. All connection routes, with the exception of Elmwood Avenue, between University Road and Lisburn Road were ruled out due to the constrained nature of the streets and significant loss of on-street residential car parking required to manoeuvre a Glider vehicle and facilitate high-levels of bus priority.</p>",
            ],
            
          },
          
          {
            imageRight:"south.png",
             imageLeft:"",
            shortHeader: "South Route",
            textAdditional:false,
             textMore: [],
            text: [
              "<h2>Route assessed as being <u>suitable</u></h2><h5>Ormeau Road</h5>",
              "<p><b>This option runs from the existing G1/ G2 network at City Hall along Great Victoria Street - Bruce Street - Bankmore Link - Ormeau Road - Saintfield Road - Cairnshill Park & Ride.</b></p>",
              "<p>From the City Centre, this option enhances access to/from Ormeau Road via a new bus-only connection on Bankmore Link (see point 3 on map). It also provides dedicated cycle lanes which enhances onward connections to the proposed Lagan Pedestrian and Cycle Bridge at the Gas Works. The route makes use of and extends existing bus lane provision along Great Victoria Street and connects to the new Belfast Transport Hub from Great Victoria Street by way of a short walk. </p> ",
              "<p>Along Ormeau Road, the scheme passes through mainly high-density residential areas. The required level of bus priority can be achieved within the existing highway boundary for the majority of the route (high-level of existing bus lane provision). Ormeau Road/Saintfield Road has strong public transport patronage and is designated as a Core Quality Bus Corridor in the Belfast Metropolitan Transport Plan. The route would enhance access to Forestside Shopping Centre and would connect to the existing Cairnshill Park & Ride which would be extended as part of the BRT2 project.</p>",
              "<h2>Routes assessed as being <u>unsuitable</u></h2>",
              "<h5>Ravenhill Road Option</h5>",
              "<p><b>This option runs along Ravenhill Road - East Bridge Street - Ormeau Road/ Ravenhill Road Roundabout Junction.</b></p>",
              "<p>The required level of bus priority cannot be provided along significant stretches of Ravenhill Road without highway widening, which would cause loss of on-street residential parking and would require 3rd party land acquisition. </p>",
              "<p>In addition, this route would connect to the City Centre via the existing G1 route, which would result in duplication of services between Short Strand and the City Centre.</p>",
              "<h5>Cairnshill to Carryduff</h5>",
               "<p><b>This option runs from Cairnshill Park & Ride - Saintfield Road - Carryduff Roundabout. </b></p>",
               "<p>Knockbracken Healthcare Centre and We are Vertigo represent the only notable attractors. There are low levels of frontage activity and low levels of residential density and as such, potential to attract future patronage is low. At some point in the future the residential developments that are planned for the area between Cairnshill and Carryduff may reach a size that will warrant a bespoke, regular interval service. Extension of a BRT2 service could be considered at that time.</p>", 
                "<h5>City Centre Connections</h5>",
               "<p><b>A number of South City Centre connection route options were ruled out as follows:</b></p>",
               "<ul><li> Ormeau Avenue</li><li>Durham Street</li><li> Bedford Street</li><li> Cromac Street</li></ul>",
                "<p>These routes offer limited carriageway width and the constrained City Centre nature results in lack of ability to provide high-levels of bus priority.</p>",
            ]         
          },
          {
            imageRight:"north.png",
            imageLeft:"north2.png",
            shortHeader: "North Routes",
            textAdditional:true,
            text: [
              "<h2>Route assessed as being <u>suitable</u></h2>",
              "<h5>Antrim Road</h5>",
              "<b>This option runs from the existing G1/G2 network at Belfast City Hall to Donegall Place - Royal Avenue - Donegall Street - Clifton Street - Carlisle Circus Roundabout - Antrim Road - Proposed Park & Ride/ Interchange facility on O’Neill Road. </b>",
              "<p>From the City Centre, this option enhances access along Antrim Road, with extended and upgraded bus lanes. A Park & Ride/Interchange location is proposed on O’Neill Road to facilitate those who wish to use their car for part of their journey or interchange to a local bus service/active travel. </p>",
              "<p>Along Antrim Road, the scheme passes through a mix of low (outer sections) and high (inner sections) density residential areas. The required level of bus priority can be achieved within the existing highway boundary for the majority of route (high-level of existing bus lane provision), with only some sections of the route requiring new bus lanes. Antrim Road benefits from high levels of existing bus patronage serving an established population catchment. It is also designated as a Core Quality Bus Corridor in the Belfast Metropolitan Transport Plan. This route would enhance access to Mater Hospital, Belfast Castle, Belfast Zoo and a number of education facilities.</p>", 
            ],
            textMore: [
             "<h5>Shore Road to O’Neill Road</h5>",
              "<b>This option runs along Donegall Place - Royal Avenue - York Street - York Road - Shore Road - Longwood Road - Proposed Park & Ride/Interchange location at O’Neill Road, as shown by the dashed line on the map.</b>", 
              "<p>From the City Centre, this option enhances access along Shore Road, with extended and upgraded bus lanes. A Park & Ride/Interchange location is proposed on O’Neill Road to facilitate those who wish to use their car for part of their journey or interchange to a local bus service/active travel.</p>",
              "<p>Along Shore Road, the scheme passes through a mix of medium to high-density residential areas. The required level of bus priority can be achieved within the existing highway boundary for the majority of the route (high-level of existing bus lane provision), with new bus lanes between Longwood Road and O’Neill Road. Shore Road benefits from high levels of existing bus patronage supported by an established population catchment. It is also designated as a Core Quality Bus Corridor in the Belfast Metropolitan Transport Plan. This route would enhance access to Ulster University, Cityside Retail Park, Abbey Centre, Longwood Retail Park, Seaview Stadium, Grove Leisure Centre, Valley Leisure Centre as well as commercial premises along Church Road.</p>",
              "<h5>Shore Road to Longwood Road</h5>",
              "<b>This option runs along Donegall Place - Royal Avenue - York Street - York Road - Shore Road - Longwood Road. </b>", 
              "<p>From the City Centre, this option enhances access along Shore Road, with extended and upgraded bus lanes. A Park & Ride/Interchange location is proposed at Longwood Road to facilitate those who wish to use their car for part of their journey or interchange to a local bus service/active travel. </p>",  
              "<p>Along Shore Road, the scheme passes through a mix of medium to high-density residential areas. The required level of bus priority can be achieved within the existing highway boundary for the majority of the route (high-level of existing bus lane provision). Shore Road benefits from high levels of existing bus patronage supported by an established population catchment. It is also designated as a Core Quality Bus Corridor in the Belfast Metropolitan Transport Plan. This route would enhance access to Ulster University, Cityside Retail Park, Abbey Centre, Longwood Retail Park, Seaview Stadium and Grove Leisure Centre.</p>"  
            ],
             textMoreAdditionalRight: [
              "<h2>Route assessed as being <u>unsuitable</u></h2>",
            "<h5>Antrim Road extending beyond O’Neill Road</h5>",
            "<b>This section runs along Antrim Road - Glengormley Town Centre.</b>",
            "<p>The required level of bus priority cannot be achieved along this section of the Antrim Road or Ballyclare Road without highway widening which would require 3rd party land acquisition. BRT services would be required to run on-street in mixed traffic and would therefore be subject to peak delays, resulting in unreliable journey times. The junction of Ballyclare Road/ Hightown Road currently experiences high traffic volumes and as such bus priority would be challenging to achieve without a significant impact on general traffic. An extension to Sandyknowes roundabout was ruled out on the basis that Sandyknowes facilitates strategic traffic movements and as such any impact on general traffic to achieve bus priority at this location would be a high risk to stakeholder and public acceptability.</p>", 
            "<h5>Shore Road extending beyond Longwood Road</h5>",
            "<b>This option runs from it’s junction with Longwood Road - Doagh Road - Station Roundabout (via either Doagh Road or A2 Station Road) - O’Neill Road - Prince Charles Way - Ballyclare Road - Proposed Park & Ride/ Interchange at Global Point Avenue.</b>", 
            "<p>The required level of bus priority cannot be achieved along the Doagh Road without significant highway widening which would require 3rd party land acquisition. BRT services would therefore be required to run along the A2 which carries strategic traffic movements from the north-east coast and facilitates access to the M5 motorway. Reallocation of road space from general traffic to bus lanes would result in a significant detriment to general traffic and lead to unacceptable levels of congestion in this area. Moving beyond the A2 at Station Road the area typically exhibits a mix of low to medium density residential areas, with low levels of frontage activity (i.e. local shops and services) and has a lack of significant attractors or generators which are needed to provide the patronage levels required to service a rapid transit scheme.</p>"
            ],
            textMoreAdditionalLeft: [
              "<h2>&nbsp;</h2>",
            "<h5>Crumlin Road</h5>",
            "<b>This option runs along Clifton Street - Carlisle Circus Roundabout - Crumlin Road - Ballysillan Road - North Circular Road - Antrim Road - Carlisle Circus Roundabout. </b>",
            "<p>The required levels of bus priority cannot be provided along Crumlin Road without highway widening, which would cause loss of on-street residential parking and would require 3rd party land acquisition. BRT services would be required to run on-street in mixed traffic and would therefore be subject to peak delays, resulting in unreliable journey times. There are limited attractors in the area beyond the Mater Hospital and Crumlin Road Gaol. Due to the lack of ability to provide a dedicated interchange or Park & Ride site, a BRT route using Crumlin Road would need to operate as a circular route in conjunction with the lower section of the Antrim Road which is not efficient nor desirable for a public transport service.</p>" ,
            "<h5>City Centre Connections</h5>",
            "<b>A number of North City Centre connection route options were ruled out as follows:</b>",
            "<ul><li>Frederick Street</li><li> Millfield</li><li> Great Patrick Street</li></ul>",
            "<p>These routes were ruled out as they would require BRT to operate along the Inner Ring Road and as such there was limited opportunity to provide high-levels of bus priority. They also do not offer a high level of City Centre access.</p>"
            
            ]
            
          },
          {
           imageRight:"sum.png",
             imageLeft:"",
            shortHeader: "Summary",
            textAdditional:false,
             textMore: [],
            text: [
                  "<h2>Route Options for Consultation</h2>",
                  "<p>Based on the assessments carried out, the three route options for consultation are presented in this section. Following this public consultation, further modelling and analysis will be undertaken to establish the preferred option.</p>", 
                  "<h5>O’Neill Road to Cairnshill Park & Ride via Antrim Road and Ormeau Road</h5>",
                   "<ul><li>The Antrim Road option which runs from the existing G1/G2 network at City Hall - Donegall Place - Royal Avenue - Donegall Street - Clifton Street - Carlisle Circus Roundabout - Antrim Road to a proposed Park & Ride/ Interchange facility on O’Neill Road. </li><li> The Ormeau Road option which runs from the existing G1/G2 network at City Hall - Great Victoria Street - Bruce Street - Bankmore Link - Ormeau Road - Ormeau Road / Ravenhill Road Roundabout - Saintfield Road to Cairnshill Park & Ride. </li><li> The Glider G2 Extension runs from the existing G2 network at Howard Street - Great Victoria Street - Bruce Street - Dublin Road - University Road, then connects with the Lisburn Road via Elmwood Avenue and back to the City Centre via Lisburn Road and Great Victoria Street. This route forms an extension to the existing G2 service which extends to the Titanic Quarter via the City Centre network.</li></ul>",
                  "<h5>O’Neill Road to Cairnshill Park & Ride via Shore Road and Ormeau Road</h5>",
                  "<ul><li>The Shore Road option which runs from the existing G1/G2 network at City Hall - Donegall Place - Royal Avenue - York Street - York Road - Shore Road - Longwood Road - Church Road to a proposed Park & Ride/Interchange facility on O’Neill Road. </li><li>The Ormeau Road option which runs from the existing G1/G2 network at City Hall - Great Victoria Street - Bruce Street - Bankmore Link - Ormeau Road - Ormeau Road / Ravenhill Road Roundabout - Saintfield Road to Cairnshill Park & Ride. </li><li>The Glider G2 Extension runs from the existing G2 network at Howard Street - Great Victoria Street - Bruce Street - Dublin Road - University Road, then connects with the Lisburn Road via Elmwood Avenue and back to the City Centre via Lisburn Road and Great Victoria Street. This route forms an extension to the existing G2 service which extends to the Titanic Quarter via the City Centre network.</li></ul>",
                  "<h5>Longwood Road to Cairnshill Park & Ride via Shore Road and Ormeau Road</h5>",
                  "<ul><li>The Shore Road option which runs from the existing G1/G2 network at City Hall - Donegall Place - Royal Avenue - York Street - York Road - Shore Road - Longwood Road to a proposed Park & Ride/ Interchange facility on Longwood Road </li><li>The Ormeau Road option which runs from the existing G1/G2 network at City Hall - Great Victoria Street - Bruce Street - Bankmore Link - Ormeau Road - Ormeau Road / Ravenhill Road Roundabout - Saintfield Road to Cairnshill Park & Ride. </li><li> The Glider G2 Extension runs from the existing G2 network at Howard Street - Great Victoria Street - Bruce Street - Dublin Road - University Road, then connects with the Lisburn Road via Elmwood Avenue and back to the City Centre via Lisburn Road and Great Victoria Street. This route forms an extension to the existing G2 service which extends to the Titanic Quarter via the City Centre network.</li></ul>" 
            ]
            
          },
          
        ],
      },
    }
  },
    methods: {
    selectStrategy(index) {
      this.strategies.selected = index;
    },
   showModalNow(imageName){
      this.imageName=imageName;
      this.showModal=true;
    },
showModalClose(){
      this.showModal=false;
    },

    openModal(imageName){
      this.imageName=imageName;
      this.modalOpen=true;
    },
    closeModal(){
      this.modalOpen=false;
    }
  },
 
  mounted() {
    // $(document).ready(function () {
    //   $(".modal").modal();
    // });
  },
  watch: {
    $route(to, from) {
      this.activeInstance = to.params.root;
    },
  },
};
</script>

<style lang="scss" scoped>

.modalOpenButton { 
 
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 0 5px 4px rgba(29, 50, 92, 0.07);

  i {
    font-size: 25px;
    padding:  6.5px 9.5px;
    color: #4b789c;
  }
}

</style>